<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <div class="form-group row">
        <div class="col-md-12">
            <!-- <yt-fw-dropdown 
            [ModelName]="'zaposleni'" 
            [GetName]="'get'" 
            [ModelProperty]="'Prezime,Ime,Jmbg'"
            formControlName="OsobaID" 
            [AllowAddNew]="false" 
            [Type]="ID" 
            [Label]="'OSOBASRODSTVO.ZAPOSLENI.SINGULAR'"
            (OnItemSelected)="onZaposleniSelect($event)">
            </yt-fw-dropdown> -->
            <yt-dropdown-picklist
                [ModelName]="'zaposleni'"
                [GetName]="'get'"
                [ModelProperty]="'Prezime,Ime,Jmbg'"
                [OrderBy]="'Prezime'"
                [AllowAddNew]="false"
                formControlName="OsobaID"
                [Label]="'OSOBASRODSTVO.ZAPOSLENI.SINGULAR'"
            >         
            </yt-dropdown-picklist>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-12">
            <yt-dropdown-picklist 
            [ModelName]="'osoba'" 
            [GetName]="'getAllWithoutOsobaId'" 
            [GetParameters]='parameterList'
            [ModelProperty]="'Prezime,Ime,Jmbg'"
            [OrderBy]="'Prezime'"
            [AllowAddNew]="true" 
            formControlName="SrodOsobaID" 
            [Label]="'OSOBASRODSTVO.SRODOSOBA.SINGULAR'">
            </yt-dropdown-picklist>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-12">
            <yt-dropdown-picklist 
                [ModelName]="'srodstvo'" 
                [GetName]="'get'" 
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="true" 
                formControlName="SrodstvoID" 
                [Label]="'OSOBASRODSTVO.SRODSTVO.SINGULAR'"
                [ShowHeader]='false'
                [ShowFooter]='false'>
            </yt-dropdown-picklist>
                
            <!-- <yt-fw-dropdown 
                [ModelName]="'srodstvo'" 
                [GetName]="'get'" 
                [ModelProperty]="'Naziv'" 
                [OrderBy]="'Naziv'"
                [AllowAddNew]='true' 
                [Required]='true' 
                [Disabled]='false' 
                formControlName="SrodstvoID" 
                name="cmbSrodstvo"
                [Type]="ID" 
                [ngClass]="{'is-invalid': submitted && fc.SrodstvoID.invalid}" 
                [Label]="'OSOBASRODSTVO.SRODSTVO.SINGULAR'">
            </yt-fw-dropdown> -->
            <div class="form-error" *ngIf="submitted && fc.SrodstvoID.invalid">
                <span *ngFor="let validation of errorMessages.SrodstvoID">
                    <span class="error-message" *ngIf="fc.SrodstvoID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-6">
            <div class="form-group row">
                <label class="col-form-label col-6">
                    <span translate="OSOBASRODSTVO.SAMOHRANIRODITELJ.SINGULAR"></span>
                </label>
                <div class="col-md-1">
                    <input style="width: 20px;" type="checkbox" name="txtSamohraniRoditelj" class="form-control"
                        formControlName="SamohraniRoditelj" autocomplete="off">
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group row">
                <label class="col-form-label col-6">
                    <span translate="OSOBASRODSTVO.OSIGURANJE.SINGULAR"></span>
                </label>
                <div class="col-md-1">
                    <input style="width: 20px;" type="checkbox" name="txtOsiguranje" class="form-control"
                        formControlName="Osiguranje" autocomplete="off">
                </div>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-12">
            <yt-number-input-v3 name="txtLbo" formControlName="Lbo" [Label]="'OSOBASRODSTVO.LBO.SINGULAR'"
                [FormatString]="'1.0-0'">
            </yt-number-input-v3>
        </div>
    </div>
</form>